import { formatPayRangeAmount } from "@components/utils/formatPayRangeAmount";

const CURRENCY_SYMBOLS = {
  USD: "$",
  GBP: "£",
  EUR: "€",
  JPY: "¥",
};

export function getCurrencySymbol(currencyCode = "USD") {
  return CURRENCY_SYMBOLS[currencyCode] || `${currencyCode} `;
}

export function formatFairPayStatusAmount(amount, currencyCode = "USD") {
  const value = Math.abs(Number(amount));
  if (!Number.isFinite(value)) {
    return "";
  }

  const symbol = getCurrencySymbol(currencyCode);

  if (value >= 1_000_000) {
    const millions = value / 1_000_000;
    const body = Number.isInteger(millions)
      ? `${millions}M`
      : `${parseFloat(millions.toFixed(1))}M`;
    return `${symbol}${body}`;
  }

  if (value >= 100_000) {
    const thousands = value / 1_000;
    const body = Number.isInteger(thousands)
      ? `${thousands}K`
      : `${parseFloat(thousands.toFixed(1))}K`;
    return `${symbol}${body}`;
  }

  return `${symbol}${value.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
}

/** Short pill amount ("$2K", "$1.5K", "$950"). Empty for a missing or zero difference, so the pill never shows "$0". */
export function formatFairPayDifferenceAmount(amount, currencyCode = "USD") {
  if (amount == null || amount === "") return "";
  const value = Math.abs(Number(amount));
  if (!Number.isFinite(value) || Math.round(value) < 1) return "";

  const symbol = getCurrencySymbol(currencyCode);
  return value < 1000 ? `${symbol}${Math.round(value)}` : `${symbol}${formatPayRangeAmount(value)}`;
}
